import React from "react"
import HoldBuilderErrors from "./HoldBuilderErrors"

class HoldBuilderTabs extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var generalErrors = []

    if(this.props.errors){
      generalErrors = HoldBuilderErrors.general(this.props.errors)
    }

    return (
      <div>
        { generalErrors.length
          ? <div className="alert alert-danger">{I18n.t('there_were_errors')}</div> 
          : null
        }

        <ul className="nav nav-tabs">
          <li role="presentation" className={this.props.active_tab === 'general' ? 'active' : null}>
            <a 
              href="#general" 
              onClick={this.props.setActiveTab.bind(null, 'general')}>
              {I18n.t('general')} { 
                generalErrors.length 
                ? <span className="badge danger">     {generalErrors.length}</span> 
                : null
              }
              
            </a>
          </li>
          <li role="presentation" className={this.props.active_tab === 'notes' ? 'active' : null}>
            <a 
              href="#notes" 
              onClick={this.props.setActiveTab.bind(null, 'notes')}>
              {I18n.t('notes')}
            </a>
          </li>
        </ul>
      </div>
    );
  } 

};

export default HoldBuilderTabs